import { AlertTriangle, CheckCircle2, ExternalLink } from "lucide-react";
import { useState } from "react";

import { urlGerenciador, urlRecarga } from "./api";
import ComoUsarLink from "./ComoUsarLink";
import { montarPassos } from "./passos";

/**
 * "Falta pouco para seu anúncio vender": o que já está pronto e o que falta,
 * cada item com o botão que resolve. Recarga e pendência abrem a Meta em
 * outra aba; o link do cardápio abre aqui mesmo, pronto para copiar.
 */
const ABRE_NA_META = { recarga: urlRecarga, gerenciador: urlGerenciador };

function Passo({ passo, aberto, onAcao }) {
  const Icone = passo.ok ? CheckCircle2 : AlertTriangle;
  const externo = Boolean(ABRE_NA_META[passo.acao]);
  return (
    <li className="flex flex-wrap items-center gap-x-3 gap-y-2 py-3" data-e2e={`meta-passo-${passo.id}`} data-ok={passo.ok ? "1" : "0"}>
      <Icone className={`w-5 h-5 shrink-0 ${passo.ok ? "text-emerald-500" : "text-amber-500"}`} />
      <div className="flex-1 min-w-[12rem]">
        <p className="text-sm font-semibold leading-tight">{passo.titulo}</p>
        {passo.detalhe && <p className="text-xs text-muted-foreground mt-0.5">{passo.detalhe}</p>}
      </div>
      {passo.acao && (
        <button onClick={() => onAcao(passo)}
          className={`inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-sm shrink-0 ${passo.ok ? "border hover:border-primary" : "bg-primary text-primary-foreground font-semibold hover:opacity-90"}`}>
          {aberto ? "Fechar" : passo.rotuloAcao} {externo && <ExternalLink className="w-3.5 h-3.5" />}
        </button>
      )}
    </li>
  );
}

export default function OQueFalta({ situacao, onIrParaMapa }) {
  const [linkAberto, setLinkAberto] = useState(false);
  const passos = montarPassos(situacao);
  const prontos = passos.filter((p) => p.ok).length;
  const tudoPronto = prontos === passos.length;

  const agir = (passo) => {
    if (passo.acao === "mapa") return onIrParaMapa();
    if (passo.acao === "link") return setLinkAberto((v) => !v);
    const abrir = ABRE_NA_META[passo.acao];
    if (abrir) window.open(abrir(situacao.conexao), "_blank", "noopener,noreferrer");
  };

  return (
    <section className="rounded-xl border bg-card p-4 sm:p-5" data-e2e="meta-o-que-falta">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="font-bold">{tudoPronto ? "Tudo pronto para o anúncio vender" : "Falta pouco para seu anúncio vender"}</h2>
          <p className="text-xs text-muted-foreground">{tudoPronto ? "Conta, área, dinheiro e link: está tudo no lugar." : "Resolva o que está em amarelo e o Núcleo passa a mostrar quanto o anúncio vendeu."}</p>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <div className="h-1.5 w-24 rounded-full bg-muted overflow-hidden">
            <div className="h-full rounded-full bg-emerald-500 transition-all" style={{ width: `${(prontos / passos.length) * 100}%` }} />
          </div>
          <span className="text-xs font-semibold tabular-nums">{prontos} de {passos.length}</span>
        </div>
      </div>
      <ul className="mt-2 divide-y">
        {passos.map((p) => <Passo key={p.id} passo={p} aberto={p.acao === "link" && linkAberto} onAcao={agir} />)}
      </ul>
      {linkAberto && <ComoUsarLink trackToken={situacao.link_anuncio?.track_token} contaNome={situacao.conexao?.ad_account_nome} />}
    </section>
  );
}
